import { identity } from 'lodash-es';
import { createSelector } from 'reselect';

const getBusinessTypeFormInitialValues = (businessType: any) => businessType;

const businessTypeFormInitialValuesSelector = createSelector(getBusinessTypeFormInitialValues, identity);

export default businessTypeFormInitialValuesSelector;
